export default {
  authorised: [
    {
      path: "/dashboard",
      name: "dashboard",
      component: () => import("@/modules/dashboard/views/DashboardView.vue"),
    },
  ],
};
